import { Styles } from 'shared/types';

export const GridItem: Styles = { display: 'flex', flexDirection: 'column' };
